import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const SliderContainerOuter = styled.section`
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
  @media (max-width: 600px) {
    height: 250px;
  }
`;

const SliderContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  transition: transform 0.6s ease-in-out;
`;

const SliderControlButton = styled.button`
  width: 50px;
  height: 50px;
  background: ${({ landingPrimaryColor }) => landingPrimaryColor};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 26px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transition: background 0.3s ease;
  &:hover {
    background: ${({ landingSecondaryColor }) => landingSecondaryColor};
  }
  &.prev {
    left: 10px;
  }
  &.next {
    right: 10px;
  }
  @media (max-width: 600px) {
    width: 30px;
    height: 30px;
    font-size: 20px;
  }
`;

const SlideContainer = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  h1 {
    max-width: 500px;
    position: absolute;
    top: 20%;
    left: 10%;
    z-index: 2;
    color: #2c2d3f;
    font-size: 38px;
    font-weight: 700;
    line-height: 50px;
    @media (max-width: 600px) {
      font-size: 20px;
      line-height: 28px;
      max-width: 80%;
    }
  }
`;

const Highlite = styled.span`
  color: ${({ landingPrimaryColor }) => landingPrimaryColor};
`;

const slidesData = [
  {
    img: '/img/sliders/01.png',
    text: (
      <>
        Instant Recharge, Anytime, Anywhere – Top Up Your{' '}
        <Highlite>Mobile</Highlite>, <Highlite>DTH</Highlite>, and{' '}
        <Highlite>More</Highlite> with Just a Click
      </>
    ),
  },
  {
    img: '/img/sliders/02.png',
    text: (
      <>
        <Highlite>Secure</Highlite> and <Highlite>Hassle-Free</Highlite> Payments – Transact Safely with Our{' '}
        <Highlite>Trusted</Highlite> Portal
      </>
    ),
  },
  {
    img: '/img/sliders/03.png',
    text: (
      <>
        Get Exclusive <Highlite>Discounts</Highlite> and <Highlite>Rewards</Highlite> on Every Recharge –{' '}
        <Highlite>Save More</Highlite> with Every Transaction
      </>
    ),
  },
  {
    img: '/img/sliders/04.png',
    text: (
      <>
        <Highlite>24/7 Availability</Highlite> – No More Waiting in Line, <Highlite>Recharge</Highlite> Your Services at Your{' '}
        <Highlite>Convenience</Highlite>
      </>
    ),
  },
];

const ImageSlider = ({ landingPrimaryColor, landingSecondaryColor }) => {
  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);

  const nextSlide = () => setIndex((prev) => (prev + 1) % slidesData.length);
  const prevSlide = () => setIndex((prev) => (prev - 1 + slidesData.length) % slidesData.length);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <SliderContainerOuter>
      <SliderContainer
        ref={sliderRef}
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {slidesData.map((slide, i) => (
          <SlideContainer key={i}>
            <img src={slide.img} alt={`Slide ${i + 1}`} />
            <h1 style={{ color: '#2c2d3f' }}>
              {React.cloneElement(slide.text, { landingPrimaryColor })}
            </h1>
          </SlideContainer>
        ))}
      </SliderContainer>

      <SliderControlButton
        className="prev"
        landingPrimaryColor={landingPrimaryColor}
        landingSecondaryColor={landingSecondaryColor}
        onClick={prevSlide}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </SliderControlButton>
      <SliderControlButton
        className="next"
        landingPrimaryColor={landingPrimaryColor}
        landingSecondaryColor={landingSecondaryColor}
        onClick={nextSlide}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </SliderControlButton>
    </SliderContainerOuter>
  );
};

export default ImageSlider;
